import { render, staticRenderFns } from "./PackingContents.vue?vue&type=template&id=64785876&"
import script from "./PackingContents.vue?vue&type=script&lang=ts&"
export * from "./PackingContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports